module.exports = __webpack_public_path__ + "static/media/america_vs_europe_logo.ffa890e5.jpg";